<div class="modal-content">
  <div class="d-flex justify-content-end align-items-center">
    <span type="button" class="close" (click)="cancelar()">X</span>
  </div>
  <h2 class="modal-title justify-content-center d-flex p-2">Atenção:</h2>

  <span *ngIf="visivel === 'mais'" class="btn-back" (click)="visivel = 'info'"> <i class="fas fa-angle-left"></i> Anterior</span>

  <div class="modal-body p-5" *ngIf="visivel === 'info'">
    <p class="aviso-texto">
      As informações cadastradas irão compor o Termo que deverá ser assinado pelos representantes legais antes do pagamento.
      Pedimos, por gentileza, que realize a validação dos dados informados para garantir que o processo ocorra sem inconsistências.
    </p>

    <p class="aviso-subtitulo justify-content-center d-flex p-2"><b>Verifique os pontos abaixo:</b></p>
    <ul class="aviso-lista d-flex flex-column mb-3">
      <li>Se plugins ou extensões do navegador estão desativados, pois podem interferir no preenchimento e envio dos dados; <span class="modal-link" (click)="visivel = 'mais'">Saiba mais.</span></li>
      <li>Se o nome da empresa e os dados dos representantes estão corretos;</li>
      <li>A conta bancária cadastrada deve ser de titularidade da empresa;</li>
      <li>O cadastro da conta deve ser feito sem o dígito, pois há campo específico para essa informação.</li>
    </ul>

    <div class="row mt-4">
      <!-- Dados dos Representantes -->
      <div class="col-md-6">
        <div class="card-secao">
          <h4 class="card-secao-titulo">Dados dos Representantes</h4>

          <div class="campo-linha">
            <span class="campo-label">CNPJ Empresa:</span>
            <span class="campo-valor">{{ cnpjFormatado }}</span>
          </div>
          <div class="campo-linha">
            <span class="campo-label">Nome/Razão Social:</span>
            <span class="campo-valor">{{ dadosEmpresa.nomeEmpresa }}</span>
          </div>

          <div *ngFor="let rep of representantes; let i = index" class="representante-bloco">
            <p class="representante-titulo">Representante {{ i + 1 }}</p>
            <div class="campo-linha">
              <span class="campo-label">Nome Completo:</span>
              <span class="campo-valor">{{ rep.nome || '-' }}</span>
            </div>
            <div class="campo-linha">
              <span class="campo-label">CPF:</span>
              <span class="campo-valor">{{ formatarCpf(rep.cpf) || '-' }}</span>
            </div>
            <div class="campo-linha">
              <span class="campo-label">E-mail:</span>
              <span class="campo-valor">{{ rep.emailPj || '-' }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Dados Bancários -->
      <div class="col-md-6">
        <div class="card-secao">
          <h5 class="card-secao-titulo">Dados Bancários</h5>

          <div class="campo-linha">
            <span class="campo-label">Banco:</span>
            <span class="campo-valor">{{ dadosBancarios.banco }}</span>
          </div>
          <div class="campo-linha">
            <span class="campo-label">Tipo Conta:</span>
            <span class="campo-valor">{{ dadosBancarios.tipoConta }}</span>
          </div>
          <div class="campo-linha">
            <span class="campo-label">Agência:</span>
            <span class="campo-valor">{{ dadosBancarios.agencia }}</span>
          </div>
          <div *ngIf="dadosBancarios.digitoAgencia" class="campo-linha">
            <span class="campo-label">Dígito Agência:</span>
            <span class="campo-valor">{{ dadosBancarios.digitoAgencia }}</span>
          </div>
          <div class="campo-linha">
            <span class="campo-label">Conta:</span>
            <span class="campo-valor">{{ dadosBancarios.conta }}</span>
          </div>
          <div class="campo-linha">
            <span class="campo-label">Dígito Conta:</span>
            <span class="campo-valor">{{ dadosBancarios.digitoConta }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-body p-5" *ngIf="visivel === 'mais'">
      <p class="section-subtitle">Para validar se você possui plugins ou extensões ativos,
        realize os procedimentos abaixo, de acordo com o navegador utilizado:
      </p>

      <div class="row justify-content-center w-100 text-left my-4">
        <div class="col-12 col-md-5 mb-4 mb-md-0">
          <h3 class="section-subs text-center">Edge ou Google Chrome</h3>
          <ul class="browsers-list pl-3">
            <li>Clique em "Configurações" (nos três pontinhos), no canto superior direito;</li>
            <li>Selecione "Extensões";</li>
            <li>Clique em Gerenciar Extensões;</li>
            <li>Serão exibidos todos os plugins e extensões do navegador.</li>
          </ul>
        </div>
        <div class="col-12 col-md-5">
          <h3 class="section-subs text-center">Safari</h3>
          <h3 class="section-subtitle">MAC</h3>
          <ul class="browsers-list ml-5">
            <li>Clique em "Safari", no canto superior esquerdo;</li>
            <li>Selecione "Configurações";</li>
            <li>Clique em "Extensões";</li>
            <li>Serão exibidos todos os plugins e extensões do navegador.</li>
          </ul>

          <h3 class="section-subtitle">iPad ou iPhone</h3>
          <ul class="browsers-list ml-5">
            <li>Selecione "Ajuste" no dispositivo;</li>
            <li>Clique em "Apps";</li>
            <li>Selecione o app "Safari";</li>
            <li>Clique em "Extensões";</li>
            <li>Serão exibidos todos os plugins e extensões do navegador.</li>
          </ul>
        </div>
      </div>

      <h3 class="section-subtitle">
        Para a utilização do Portal do Investidor é necessário que todos os
        plugins ou extensões do navegador estejam desativados.
      </h3>
    </div>

  <div class="d-flex justify-content-center" *ngIf="visivel === 'info'">
    <button class="btn btn-confirmar mr-2" (click)="confirmar()">Confirmar</button>
    <button class="btn btn-cancelar" (click)="cancelar()">Corrigir</button>
  </div>

  <div class="d-flex justify-content-center" *ngIf="visivel === 'mais'">
    <button class="btn-ok" (click)="visivel = 'info'">OK</button>
  </div>
</div>
